/**
 * Grading Service
 */

import api from '../lib/api';

export const gradingService = {
  // Class Grading Settings
  async getGradingSettings(classId) {
    const response = await api.get(`/grading/classes/${classId}/grading/settings`);
    return response.data;
  },

  async createGradingSettings(classId, data) {
    const response = await api.post(`/grading/classes/${classId}/grading/settings`, data);
    return response.data;
  },

  async updateGradingSettings(classId, data) {
    const response = await api.put(`/grading/classes/${classId}/grading/settings`, data);
    return response.data;
  },

  // Grades
  async getClassGrades(classId, params = {}) {
    const response = await api.get(`/grading/classes/${classId}/grades`, { params });
    return response.data;
  },

  async createGrade(classId, data) {
    const response = await api.post(`/grading/classes/${classId}/grades`, data);
    return response.data;
  },

  async updateGrade(gradeId, data) {
    const response = await api.put(`/grading/grades/${gradeId}`, data);
    return response.data;
  },

  async deleteGrade(gradeId) {
    const response = await api.delete(`/grading/grades/${gradeId}`);
    return response.data;
  },

  // Student Grades
  async getStudentGrades(studentId, params = {}) {
    const response = await api.get(`/grading/students/${studentId}/grades`, { params });
    return response.data;
  },

  // Reporting Periods
  async getReportingPeriods(classId) {
    const response = await api.get(`/grading/classes/${classId}/reporting-periods`);
    return response.data;
  },

  async createReportingPeriod(classId, data) {
    const response = await api.post(`/grading/classes/${classId}/reporting-periods`, data);
    return response.data;
  },

  async releaseGrades(periodId) {
    const response = await api.post(`/grading/reporting-periods/${periodId}/release`);
    return response.data;
  },

  // Grade Summaries
  async getGradeSummaries(classId) {
    const response = await api.get(`/grading/classes/${classId}/grade-summaries`);
    return response.data;
  },

  // Student Notes
  async getStudentNotes(classId, studentId, params = {}) {
    const response = await api.get(`/grading/classes/${classId}/students/${studentId}/notes`, { params });
    return response.data;
  },

  async createNote(classId, studentId, data) {
    const response = await api.post(`/grading/classes/${classId}/students/${studentId}/notes`, data);
    return response.data;
  },

  async updateNote(noteId, data) {
    const response = await api.put(`/grading/notes/${noteId}`, data);
    return response.data;
  },

  async deleteNote(noteId) {
    const response = await api.delete(`/grading/notes/${noteId}`);
    return response.data;
  },

  async getFollowUpNotes(classId) {
    const response = await api.get(`/grading/classes/${classId}/notes/follow-up`);
    return response.data;
  }
};
